module.exports = __webpack_public_path__ + "static/5b05026f7e71c11aafd57f4f8910b3a18016da37a8ffb5c2ab2f189941a935b7-1d73cbe730691130e6e345434f9776bf.png";